import { OAuthAPI } from "./oauth";

export class OAuth1API extends OAuthAPI {}

export default OAuth1API;
